<template>
  <div class="card">
    <loading :active.sync="loading" :is-full-page="true" />
    <div class="card-body">
      <div class="form-row">
        <div class="form-group col-md-12">
          <label>ASN</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control form-control-md"
              placeholder="Pesquisar..."
              v-model="parameter"
            />
            <span class="input-group-append">
              <button
                class="btn btn-primary"
                @click="send"
                @keydown.enter="send"
              >
                <i class="fas fa-search"></i> Buscar
              </button>
            </span>
          </div>
        </div>
      </div>

      <pre>
        {{ result }}
      </pre>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";

export default {
  components: {
    Loading
  },
  data() {
    return {
      loading: false,
      parameter: null,
      result: {}
    };
  },

  methods: {
    send() {
      this.loading = true;

      axios.get(`https://api.bgpview.io/asn/${this.parameter}`).then(res => {
        this.result = res.data.data;
        this.loading = false;
      });
    }
  }
};
</script>
